export default __webpack_public_path__ + "static/media/background.173b1cf3.png";